// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-page-templates-account-index-js": function componentSrcPageTemplatesAccountIndexJs() {
    return import("./../../src/page-templates/account/index.js"
    /* webpackChunkName: "component---src-page-templates-account-index-js" */
    );
  },
  "component---src-page-templates-article-index-js": function componentSrcPageTemplatesArticleIndexJs() {
    return import("./../../src/page-templates/article/index.js"
    /* webpackChunkName: "component---src-page-templates-article-index-js" */
    );
  },
  "component---src-page-templates-checkout-confirmation-js": function componentSrcPageTemplatesCheckoutConfirmationJs() {
    return import("./../../src/page-templates/checkout/confirmation.js"
    /* webpackChunkName: "component---src-page-templates-checkout-confirmation-js" */
    );
  },
  "component---src-page-templates-checkout-index-js": function componentSrcPageTemplatesCheckoutIndexJs() {
    return import("./../../src/page-templates/checkout/index.js"
    /* webpackChunkName: "component---src-page-templates-checkout-index-js" */
    );
  },
  "component---src-page-templates-folder-index-js": function componentSrcPageTemplatesFolderIndexJs() {
    return import("./../../src/page-templates/folder/index.js"
    /* webpackChunkName: "component---src-page-templates-folder-index-js" */
    );
  },
  "component---src-page-templates-frontpage-js": function componentSrcPageTemplatesFrontpageJs() {
    return import("./../../src/page-templates/frontpage.js"
    /* webpackChunkName: "component---src-page-templates-frontpage-js" */
    );
  },
  "component---src-page-templates-my-account-index-js": function componentSrcPageTemplatesMyAccountIndexJs() {
    return import("./../../src/page-templates/my-account/index.js"
    /* webpackChunkName: "component---src-page-templates-my-account-index-js" */
    );
  },
  "component---src-page-templates-product-index-js": function componentSrcPageTemplatesProductIndexJs() {
    return import("./../../src/page-templates/product/index.js"
    /* webpackChunkName: "component---src-page-templates-product-index-js" */
    );
  },
  "component---src-page-templates-search-index-js": function componentSrcPageTemplatesSearchIndexJs() {
    return import("./../../src/page-templates/search/index.js"
    /* webpackChunkName: "component---src-page-templates-search-index-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  }
};